import { render } from "./Quality.vue?vue&type=template&id=4f2afe89&scoped=true&ts=true"
import script from "./Quality.vue?vue&type=script&lang=ts"
export * from "./Quality.vue?vue&type=script&lang=ts"

import "./Quality.vue?vue&type=style&index=0&id=4f2afe89&scoped=true&lang=less"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2afe89"]])

export default __exports__